// studioLayout.js

export const STUDIO_PANEL_WIDTHS_STORAGE_KEY = 'orbital.studio.panelWidths';

export const STUDIO_EXPLORER_DEFAULT_WIDTH = 300;
export const STUDIO_EXPLORER_MIN_WIDTH = 220;
export const STUDIO_EXPLORER_MAX_WIDTH = 520;

export const STUDIO_LAYOUT_INSPECTOR_DEFAULT_WIDTH = 250;
export const STUDIO_LAYOUT_INSPECTOR_MIN_WIDTH = 250;
export const STUDIO_LAYOUT_INSPECTOR_MAX_WIDTH = 480;
